// extracted by mini-css-extract-plugin
module.exports = {"list":"MultiDurationSelectorStyles_list__8mMRn","item":"MultiDurationSelectorStyles_item__OhyDx"};